import createModule from "../createModule"
import { getFilter, getFilterId } from "modules/watchlist/selectors"
import { getFacetTypes, getRawClassifications, getClassifications } from "./selectors"
import { Creators } from "./model"
import { generateClassificationFacetQuery } from "helpers/classification"
import { mapFactorExposureNegativeBoolOperator } from "helpers/filters"
import view from "./view"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    modelId: props.modelId,
    id: state.modules.watchlist.id,
    filter: getFilter(state, props),
    filterId: getFilterId(state, props),
    classifications: getRawClassifications(state, props),
  }),
  required: ["account", "modelId", "classifications"],
  data: [{
    resource: "watchlistFacets",
    url: ({ modelId, filterId, filter, selectedDate, classifications }) => {
      if (!filterId) {
        return null
      }

      filter = mapFactorExposureNegativeBoolOperator(filter)

      return {
        id: `${modelId}${filterId}${selectedDate}`,
        options: {
          ignoreMessages: true, // messages already handled by full query
        },
        query: `query ($modelId: String!, $filter: [SecuritySearchFilter!]!, $on: Date!) {
          model (id: $modelId) {
            securitySearch (filter: $filter, on: $on) {
              count
              countries {
                id
                count
              }
              ${generateClassificationFacetQuery(classifications)}
              currencies {
                id
                count
              }
            }
          }
        }`,
        variables: {
          modelId,
          filter,
          on: selectedDate,
        },
      }
    },
  }],
  actions: Creators,
  mapStateToProps: (state, props) => ({
    ...state.modules.watchlistFacets,
    facetTypes: getFacetTypes(state, props),
    expanded: state.modules.watchlistFacets.expanded,
    classifications: getClassifications(state, props),
  }),
})
